import React, { useContext } from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { mediaQuery } from "@zendeskgarden/react-theming"
import { TabPanel } from "@zendeskgarden/react-tabs"
import { searchResult } from "../../lib/prop-types"
import SearchModalContext from "./searchModalContext"
import NoResultsFound from "./noResultsFound"
import SearchResult from "./searchResult"
import SearchLoader from "./searchLoader"

const SearchResultList = styled.ul`
  margin: ${props => `-${props.theme.space.lg}`};

  ${props => mediaQuery("down", "sm", props.theme)} {
    margin: ${props =>
      `-${props.theme.space.md} -${props.theme.space.horz.md}`};
  }
`

const SearchResultsTabPanel = ({
  item,
  visible,
  loading,
  results,
  searchTerm
}) => {
  const { resultsListRef } = useContext(SearchModalContext)

  const resultsListAriaLabel = `${
    item === "tab-documentation" ? "Documentation" : "API reference"
  } search results`

  const returnedResults =
    results.length === 0 ? (
      <NoResultsFound searchTerm={searchTerm} />
    ) : (
      <SearchResultList
        ref={visible ? resultsListRef : null}
        aria-label={resultsListAriaLabel}
      >
        {results.map(result => {
          // eslint-disable-next-line no-underscore-dangle
          const highlightResult = result._highlightResult
          return (
            <li key={result.slug}>
              <SearchResult
                slug={result.slug}
                title={result.title}
                highlightedTitle={highlightResult.title.value}
                articlePlainText={highlightResult.articlePlainText.value}
                breadcrumbs={result.breadcrumbs}
              />
            </li>
          )
        })}
      </SearchResultList>
    )

  return (
    <TabPanel item={item}>
      {loading ? <SearchLoader /> : returnedResults}
    </TabPanel>
  )
}

SearchResultsTabPanel.propTypes = {
  item: PropTypes.string,
  visible: PropTypes.bool.isRequired,
  loading: PropTypes.bool,
  searchTerm: PropTypes.string,
  results: PropTypes.arrayOf(PropTypes.shape(searchResult))
}

SearchResultsTabPanel.defaultProps = {
  item: "tab-documentation",
  loading: false,
  searchTerm: "",
  results: []
}

export default SearchResultsTabPanel
